import React from 'react';
import SlideUpDownNav from './../inc/SlideUpDownNav';


class Services2 extends React.Component {
    constructor(props) {
        super(props);
        this.openModal = this.openModal.bind(this)
        this.closeModal = this.closeModal.bind(this)
    }

    openModal(e){
        let root = document.getElementsByTagName('html')[0];
        let allModals = document.querySelectorAll('.mole__side--modal');
        let openModals = document.querySelectorAll('.section--links > a');
        let closeModals = document.querySelectorAll('.close-modal');

        let heading = e.currentTarget.querySelector('span').innerHTML;
        document.querySelector('.mole__side--modal.is-showing') ? document.querySelector('.mole__side--modal.is-showing').classList.remove('is-showing') : '' ;
        document.querySelector('.mole__side--modal[data-lbl="'+heading+'"]').classList.add('is-showing');
        root.classList.add('bound');
        
    }

    closeModal(e){
        let root = document.getElementsByTagName('html')[0];
        let modal = e.currentTarget;
        let heading = modal.dataset.lbl;
        document.querySelector('.mole__side--modal[data-lbl="'+heading+'"]').classList.remove('is-showing');
        root.classList.remove('bound');
    }

    componentDidMount(){
        // open and close modal
        let root = document.getElementsByTagName('html')[0];
        let allModals = document.querySelectorAll('.mole__side--modal');
        let openModals = document.querySelectorAll('.section--links > a');
        let closeModals = document.querySelectorAll('.close-modal');
       
        // close modal on Esc press
        window.addEventListener('keydown', (e) => {
            if(e.key == "Escape") {
                if(document.querySelector('.mole__side--modal.is-showing')){
                    document.querySelector('.mole__side--modal.is-showing').classList.remove('is-showing');
                    root.classList.remove('bound');
                }
            }
        });
    }

    render() {
        let _this = this;
        let page_id = this.props.page_id;
        let services = this.props.pages.pageData[page_id] ? this.props.pages.pageData[page_id].acf.about_services_content : [];  
        let description = this.props.pages.pageData[page_id] ? this.props.pages.pageData[page_id].acf.services_description : []; 
        return (
            <section className="section" data-anchor="services" data-logo="hide">
                
                <div className="mole__about--values fullW">
                    <div className="main-container">
                        <div className="inner-container">
                            <h4 className="font-lg-head section--title c-general">Services</h4>


                            <div className="grid">
                                <div className="grid-item">
                                    <div className="font-lg section--links d-inline-flex flex-column align-items-start">
                                        {
                                            services.map((service, index) => {
                                                return (
                                                    <a href="javascript:" key={index} onClick={_this.openModal}><span>{service.service_heading}</span></a>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                                {
                                    description != '' &&
                                        <div className="grid-item">
                                            <article className="font-md section--content d-inline-block" dangerouslySetInnerHTML={{__html: description}} />
                                        </div>
                                }
                            </div>

                            <div className="section--modals">
                                {
                                    services.map((service, index) => {
                                        return (
                                            <section className="mole__side--modal fixed font-md bg-general" key={index} data-lbl={service.service_heading}> 
                                                <div className="main-container">
                                                    <div className="inner-container">
                                                        <div className="desc">
                                                            <h5>Services</h5>
                                                            <h6 className="c-white">{service.service_heading}</h6>
                                                            <p></p>
                                                        </div>
                                                        <article className="desc" dangerouslySetInnerHTML={{__html:service.service_content}} />
                                                        <figure>
                                                            <img className="w-100" src={service.service_image.url}  alt={service.service_image.alt} />
                                                        </figure>
                                                        <a href="javascript:" className="link btn_prev close-modal c-white c-hvr-txt" data-lbl={service.service_heading} onClick={_this.closeModal}>Back</a>
                                                    </div>
                                                </div>
                                            </section>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>

            </section>
        );
    }
}
export default Services2;



// WEBPACK FOOTER //
// ./src/components/About/Services2.js